import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Grid} from '@material-ui/core';
import {autobind} from 'core-decorators';
import Text from 'components/text';
import {reverse} from 'core/urls';
import {Form, Field, Input, Textarea, LocalitySelect} from 'components/forms';
import SectionBanner from 'components/section-banner';
import Button from 'components/button';
import styles from './styles.css';

@autobind
export default class AddressForm extends Component {
    static propTypes = {
        address: PropTypes.object,
        dataKey: PropTypes.string.isRequired,
        returnUrl: PropTypes.string,
        returnData: PropTypes.object,
        onSubmit: PropTypes.func.isRequired,
    };

    static contextTypes = {
        router: PropTypes.object,
    };

    state = {};

    async handleSubmit(values) {
        this.setState({loading: true, errors: undefined});

        const {lng, lat} = values;
        values.lng = lng ? Number(lng) : undefined;
        values.lat = lat ? Number(lat) : undefined;

        const response = await this.props.onSubmit(values);

        if (response.data[this.props.dataKey].errors) {
            this.setState({
                loading: false,
                errors: response.data[this.props.dataKey].errors,
            });
        } else if (this.props.returnUrl) {
            this.context.router.history.push({
                pathname: this.props.returnUrl,
                state: {
                    returnData: {
                        ...(this.props.returnData || {}),
                        address: response.data.createAddress.address.id,
                    },
                },
            });
        } else {
            this.context.router.history.push(reverse('addressBook'));
        }
    }

    handlePreviousPage() {
        if (this.props.returnUrl) {
            this.context.router.history.push({
                pathname: this.props.returnUrl,
                state: {
                    returnData: {
                        ...(this.props.returnData || {}),
                    },
                },
            });
        } else {
            this.context.router.history.push(reverse('addressBook'));
        }
    }

    render() {
        const address = this.props.address || {locality: {}};

        return (
            <div className={styles.root}>
                <SectionBanner />
                <Form
                    fields={[
                        {key: 'name', initial: address.name || ''},
                        {key: 'locality', initial: address.locality.id || ''},
                        {key: 'postalCode', initial: address.postalCode || ''},
                        {key: 'street', initial: address.street || ''},
                        {key: 'phone', initial: address.phone || ''},
                        {key: 'lat', initial: address.lat || '', required: false},
                        {key: 'lng', initial: address.lng || '', required: false},
                        {key: 'notes', initial: address.notes, required: false},
                        {key: 'isDefault', initial: false, required: false},
                    ]}
                    errors={this.state.errors}
                    onSubmit={this.handleSubmit}>
                    {({getFieldProps, renderErrors, isValid}) => (
                        <div>
                            <Grid container spacing={2} className={styles.form} justify='space-between'>
                                <Grid item xs={12} md={4}>
                                    <Field label='Título de la dirección(*)'>
                                        <Input type='text' {...getFieldProps('name')} />
                                        {renderErrors('name')}
                                    </Field>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Field label='Localidad(*)'>
                                        <LocalitySelect {...getFieldProps('locality')} />
                                        {renderErrors('locality')}
                                    </Field>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Field label='Código postal(*)'>
                                        <Input type='text' {...getFieldProps('postalCode')} />
                                        {renderErrors('postalCode')}
                                    </Field>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Field label='Dirección(*)'>
                                        <Input type='text' {...getFieldProps('street')} />
                                        {renderErrors('street')}
                                    </Field>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Field label='Teléfono(*)'>
                                        <Input type='text' {...getFieldProps('phone')} />
                                        {renderErrors('phone')}
                                    </Field>
                                </Grid>
                                <Grid item xs={6} md={2}>
                                    <Field label='Latitud'>
                                        <Input type='number' {...getFieldProps('lat')} />
                                        {renderErrors('lat')}
                                    </Field>
                                </Grid>
                                <Grid item xs={6} md={2}>
                                    <Field label='Longitud'>
                                        <Input type='number' {...getFieldProps('lng')} />
                                        {renderErrors('lng')}
                                    </Field>
                                </Grid>
                                <Grid item xs={12}>
                                    <Field label='Comentarios'>
                                        <Textarea {...getFieldProps('notes')} />
                                        {renderErrors('notes')}
                                    </Field>
                                </Grid>
                                <Grid item xs={12}>
                                    {renderErrors('__all__')}
                                    <Text variant='h4'>Campo Obligatorio (*)</Text>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} className={styles.buttonsContainer}>
                                <Grid item xs={6}>
                                    <Button type='button' theme='white' onClick={this.handlePreviousPage}>
                                        <Text bold='bold' variant='h4'>Volver</Text>
                                    </Button>
                                </Grid>
                                <Grid item xs={6} className={styles.buttonContainer}>
                                    <Button type='submit' theme='yellow' disabled={!isValid() || this.state.loading}>
                                        {this.state.loading ? 'GUARDANDO...' : 'GUARDAR DIRECCIÓN'}
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>
                    )}
                </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/addresses/address-form/index.js